<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="phone-volume"/>
          {{ $t('callPackage') }}
        </h1>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="tile">
          <div class="form-inline">
            <form-select :model="filterFormModel" attribute="group" class="mr-1" :options="[
                    {value: 'day', text: $t('byDay')},
                    {value: 'month', text: $t('byMonth')},
                    {value: 'client', text: $t('byClient')}
                    ]"></form-select>
            <client-select :model="filterFormModel" attribute="client" @input="load" :isFilter="true"
                           :place-holder="$t('selectClient') "
                           class="mr-1"></client-select>
            <time-range-picker :model="filterFormModel" @input="load" :label="$t('time')" :default-shortcut="2"
                               class="mr-1"></time-range-picker>
            <button @click="load" class="btn btn-primary mr-1">{{ $t('search') }}</button>
            <button @click="reset" class="btn btn-secondary mr-1">Reset</button>
          </div>
        </div>
        <template>
          <div class="tile">
            <div class="table-responsive c-template-table">
              <table class="table table-hover table-bordered">
                <thead>
                <tr>
                  <th class="text-center"></th>
                  <th class="text-center">{{ $t('orderNumber') }}</th>
                  <th class="text-center">{{ $t('packagesPurchased') }}</th>
                  <th class="text-center">{{ $t('money') }}</th>
                  <th class="text-center">{{ $t('callMinutes') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr class="bg-success">
                  <td><b class="text-uppercase">{{ $t('total') }}</b></td>
                  <td class="text-center"><span class="text-blue">{{ sum.order | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ sum.package | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ sum.total | numFormat }}</span></td>
                  <td class="text-center"><span
                      class="text-blue">{{ (sum.billDuration ? sum.billDuration : 0) | callDuration }}</span></td>
                </tr>
                <tr class="bg-warning">
                  <td><b class="text-uppercase">{{ $t('average') }}</b></td>
                  <td class="text-center"><span class="text-blue">{{ avg.order  | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ avg.package | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ avg.total  | numFormat }}</span></td>
                  <td class="text-center"><span
                      class="text-blue">{{ (avg.billDuration ? avg.billDuration : 0)  | callDuration }}</span></td>
                </tr>
                <tr :key="index" v-for="(item, index) in data">
                  <td style="min-width: 200px"><b>{{ label(item) }}</b></td>
                  <td class="text-center"><span class="text-blue">{{ item.order | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ item.package | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ item.total | numFormat }}</span></td>
                  <td class="text-center"><span
                      class="text-blue">{{ (item.billDuration ? item.billDuration : 0) | callDuration }}</span></td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </template>
      </div>
    </div>
  </main>
</template>

<script>
import TimeRangePicker from "../../components/TimeRangePicker";
import moment from 'moment';
import ClientSelect from "../../components/ClientSelect";

export default {
  components: {ClientSelect, TimeRangePicker},
  data: function () {
    return {
      filterFormModel: {
        group: 'day',
        client: null,
      },
      loading: true,
      data: [],
      sum: {},
      avg: {}
    }
  },
  methods: {
    load() {
      let loader = this.$loading.show();
      this.loading = true;
      this.filterFormModel.to = moment(this.filterFormModel.to, 'x').endOf('day').format('x');
      this.$service.get('/report/call-package', {
        params: this.filterFormModel
      }).then(response => {
        this.data = response.data;
        this.sum = {};
        this.avg = {};
        this.data.forEach(item => {
          for (let key in item) {
            if (key !== 'label') {
              item[key] = Math.abs(item[key]);
              if (!this.sum[key]) {
                this.sum[key] = 0;
              }
              this.sum[key] += Math.abs(item[key]);
            }
          }
        });
        for (let key in this.sum) {
          this.avg[key] = Math.round(this.sum[key] / this.data.length);
        }
      }).finally(() => {
        loader.hide();
        this.loading = false;
      });
    },
    label(item) {
      if (item.label) {
        return item.label;
      }
      if (item._id.month) {
        return `${item._id.month > 9 ? item._id.month : '0' + item._id.month}/${item._id.year}`;
      }
      if (!isNaN(item._id)) {
        return moment(this.filterFormModel.from + item._id, 'x').format('DD/MM/YYYY');
      }
    },
    reset() {
      this.filterFormModel = {
        group: 'day',
        client: null,
        from: moment().startOf('month').toDate().getTime(),
        to: moment().endOf('month').toDate().getTime()
      };
      this.load()
    }
  },
  mounted() {
    this.load();
  },
  i18n: {
    messages: {
      en: {
        callPackage: 'All-inclusive calling package',
        byDay: 'By day',
        byMonth: 'By month',
        byClient: 'By client',
        sum: 'Sum',
        avg: 'Average',
        packagesPurchased: 'Number of packages purchased',
        money: 'Amount of money',
        callMinutes: 'Call minutes',
        orderNumber: 'Order number',
      },
      vi: {
        callPackage: 'Gói gọi trọn gói',
        byDay: 'Theo ngày',
        byMonth: 'Theo tháng',
        byClient: 'Theo khách hàng',
        sum: 'Tổng',
        avg: 'Trung bình',
        packagesPurchased: 'Số gói mua',
        money: 'Số tiền',
        callMinutes: 'Số phút gọi',
        orderNumber: 'Số đơn hàng',
      }
    }
  }
}
</script>